module.exports = __webpack_public_path__ + "static/media/mon-sun_and_everyday_digital_cropped.94259b6c.png";